<script>
    import { onMount, onDestroy } from "svelte";
    import { navigateTo } from "svelte-router-spa";

    // ── Image URLs (S3) ────────────────────────────────
    const S3 =
        "https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/index-images";
    const IMG = {
        heroLogo: `${S3}/index_heroLogo.png`,
        iconMoney: `${S3}/index_iconMoney.png`,
        iconHeart: `${S3}/index_iconHeart.png`,
        iconPhone: `${S3}/index_iconPhone.png`,
        iconRobot: `${S3}/index_iconRobot.png`,
        heroApps: `${S3}/index_heroApps.png`,
        beforeCard: `${S3}/index_beforeCard.png`,
        afterCard: `${S3}/index_afterCard.png`,
        beforeHero: `${S3}/index_beforeHero.png`,
        afterPhone: `${S3}/index_afterPhone.png`,
        iconInsta: `${S3}/index_iconInsta.png`,
        iconNaver: `${S3}/index_iconNaver.png`,
        iconMail: `${S3}/index_iconMail.png`,
        iconYoutube: `${S3}/index_iconYoutube.png`,
        dragdropCard: `${S3}/index_dragdropCard.png`,
        perfCard: `${S3}/index_perfCard.png`,
        tmplPhone1: `${S3}/index_tmplPhone1.png`,
        tmplPhone2: `${S3}/index_tmplPhone2.png`,
        aiTextCard: `${S3}/index_aiTextCard.png`,
        aiPhoneCard: `${S3}/index_aiPhoneCard.png`,
        featMiniP_l: `${S3}/index_featMiniP_l.png`,
        featMiniP_r: `${S3}/index_featMiniP_r.png`,
        featMiniP_c: `${S3}/index_featMiniP_c.png`,
        featMobilePhone: `${S3}/index_featMobilePhone.png`,
        featMobileCards: `${S3}/index_featMobileCards.png`,
        featCharPhone: `${S3}/index_featCharPhone.png`,
        tmplGallP_l: `${S3}/index_tmplGallP_l.png`,
        tmplGallP_r: `${S3}/index_tmplGallP_r.png`,
        tmplGallP_c: `${S3}/index_tmplGallP_c.png`,
        bottomShot: `${S3}/index_bottomShot.png`,
    };

    // ── Hero slider data ────────────────────────────────
    const SLIDES = [
        {
            headline: "내 비즈니스를 알리는 가장 쉬운 방법.",
            sub: "공짜로 나만의 미니홈페이지를 제작해 보세요.",
            icon: null,
        },
        {
            headline: "하루 500원으로 홍보부터 응대까지",
            sub: "사탕 하나값으로 내 비즈니스 알리고, 단순 문의까지 한 번에 해결하세요.",
            icon: "iconMoney",
        },
        {
            headline: "나에게 맞을지, 무료로 먼저 써보세요",
            sub: "결제 없이 가볍게, 일주일 동안 내 일에 맞는지 먼저 경험해 보세요.",
            icon: "iconHeart",
        },
        {
            headline: "흩어진 내 비즈니스, 링크 하나에",
            sub: "SNS부터 예약까지. 흩어진 내 정보를 한곳에 모아 쉽고 깔끔하게 홍보하세요.",
            icon: "iconPhone",
        },
        {
            headline: "퇴근 후에도 내 비즈니스는 멈추지 않게",
            sub: "24시간 손님 응대와 중요한 문의를 빠짐없이 받아두는 AI매니저",
            icon: "iconRobot",
        },
    ];

    let current = 0;
    let timer;

    function goTo(i) {
        current = (i + SLIDES.length) % SLIDES.length;
    }
    function next() {
        goTo(current + 1);
    }
    function prev() {
        goTo(current - 1);
    }

    function startTimer() {
        timer = setInterval(next, 4500);
    }
    function resetTimer() {
        clearInterval(timer);
        startTimer();
    }

    onMount(() => {
        startTimer();
    });
    onDestroy(() => clearInterval(timer));
</script>

<div id="idx">
    <!-- ── Hero Slider ── -->
    <section class="hero">
        <!-- decorative blur ellipses -->
        <div class="hero-blur pink"></div>
        <div class="hero-blur blue"></div>

        <div class="hero-content">
            <!-- 슬라이드 영역: 고정 높이로 controls 위치 고정 -->
            <div class="slides-outer">
                {#each SLIDES as slide, i}
                    <div
                        class="slide"
                        class:active={i === current}
                        aria-hidden={i !== current}
                    >
                        <div class="brand-row">
                            <img src={IMG.heroLogo} alt="" class="brand-icon" />
                            <h1 class="brand">AVATALK</h1>
                        </div>
                        <div class="hero-h-row">
                            <h2 class="hero-h">{slide.headline}</h2>
                            {#if slide.icon}
                                <img
                                    src={IMG[slide.icon]}
                                    alt=""
                                    class="hero-icon"
                                />
                            {/if}
                        </div>
                        <p class="hero-sub">{slide.sub}</p>
                        <button
                            class="btn-cta"
                            on:click={() => navigateTo("/character-chat")}
                        >
                            무료로 제작하기
                        </button>
                    </div>
                {/each}
            </div>

            <!-- controls: slides-outer 밖에 위치해 높이 변화 영향 없음 -->
            <div class="hero-controls">
                <button
                    class="ctrl-arrow"
                    on:click={() => {
                        prev();
                        resetTimer();
                    }}
                    aria-label="이전"
                >
                    <svg width="28" height="28" viewBox="0 0 16 16" fill="none"
                        ><path
                            d="M10 12L6 8l4-4"
                            stroke="#3C3D46"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        /></svg
                    >
                </button>
                <div class="dots">
                    {#each SLIDES as _, i}
                        <button
                            class="dot"
                            class:active={i === current}
                            on:click={() => {
                                goTo(i);
                                resetTimer();
                            }}
                            aria-label="슬라이드 {i + 1}"
                        ></button>
                    {/each}
                </div>
                <button
                    class="ctrl-arrow"
                    on:click={() => {
                        next();
                        resetTimer();
                    }}
                    aria-label="다음"
                >
                    <svg width="28" height="28" viewBox="0 0 16 16" fill="none"
                        ><path
                            d="M6 4l4 4-4 4"
                            stroke="#3C3D46"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        /></svg
                    >
                </button>
            </div>
        </div>
    </section>

    <!-- ── Problem / Solution ── -->
    <section class="sec problem-sec">
        <div class="idx-wrap prob-grid">
            <div class="prob-text">
                <h2 class="sh">홍보하랴, 응대하랴<br />바쁜 당신을 위해</h2>
                <p class="sp">
                    흩어진 정보 정리하고, 쏟아지는 문의에 답하느라 지치셨나요?<br
                    />
                    이제 홍보는 미니홈페이지에 맡기고, 24시간 문의는 AI 매니저에게
                    맡기세요.
                </p>
            </div>
            <div class="prob-img">
                <img src={IMG.heroApps} alt="앱 미리보기" />
            </div>
        </div>
    </section>

    <!-- ── Before / After ── -->
    <section class="sec ba-sec">
        <div class="idx-wrap grid-2">
            <div class="ba-card before-card">
                <span class="ba-card-label">Before</span>
                <h3 class="ba-card-h">
                    이곳저곳 흩어진 정보,<br />쏟아지는 문의들
                </h3>
                <img
                    src={IMG.beforeHero}
                    alt="흩어진 문의 상황"
                    class="ba-hero-img"
                />
            </div>
            <div class="ba-card after-card">
                <span class="ba-card-label">After</span>
                <h3 class="ba-card-h">아바톡으로 모든걸<br />깔끔하게 해결</h3>
                <div class="after-icons-area">
                    <div class="after-icons-grid">
                        <img
                            src={IMG.iconInsta}
                            alt="Instagram"
                            class="after-icon"
                        />
                        <img
                            src={IMG.iconNaver}
                            alt="Naver"
                            class="after-icon"
                        />
                        <img src={IMG.iconMail} alt="메일" class="after-icon" />
                        <img
                            src={IMG.iconYoutube}
                            alt="YouTube"
                            class="after-icon"
                        />
                    </div>
                    <svg
                        class="after-arrow"
                        width="20"
                        height="16"
                        viewBox="0 0 20 16"
                        fill="none"
                        aria-hidden="true"
                    >
                        <path
                            d="M1 8H19M12 1l7 7-7 7"
                            stroke="#3C3D46"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <img
                    src={IMG.afterPhone}
                    alt="아바톡 화면"
                    class="after-phone-img"
                />
            </div>
        </div>
    </section>

    <!-- ── Drag & Drop ── -->
    <section class="sec dragdrop-sec">
        <div class="idx-wrap">
            <h2 class="sh">블록 쌓듯 뚝딱!<br />코딩 없이 간단하게 완성.</h2>
            <p class="sp">
                디자인 고민은 내려고 텍스트, 이미지, 유튜브, 예약 링크 등<br
                />필요한 블록을 끌어다 놓기만 하면 끝나요.
            </p>
            <div class="dd-card">
                <div class="dd-text">
                    <span class="dd-tag">Drag &amp; Drop</span>
                    <h3 class="dd-card-h">
                        원하는 블록 추가 드래그 앤<br />드롭으로 쉽게 구성
                    </h3>
                </div>
                <div class="dd-img-wrap">
                    <img
                        src={IMG.dragdropCard}
                        alt="드래그 앤 드롭 기능"
                        class="dd-img"
                    />
                </div>
            </div>
        </div>
    </section>

    <!-- ── Performance + Template ── -->
    <section class="sec dual-sec">
        <div class="idx-wrap dual-cards">
            <div class="dual-card tmpl-card">
                <span class="dc-tag">Template</span>
                <h3 class="dc-h">
                    감각적인 템플릿으로<br />누구나 프로처럼 만들어보세요.
                </h3>
                <img
                    src={IMG.tmplPhone1}
                    alt=""
                    class="tmpl-phone tmpl-phone-1"
                />
                <img
                    src={IMG.tmplPhone2}
                    alt=""
                    class="tmpl-phone tmpl-phone-2"
                />
            </div>
            <div class="dual-card perf-card">
                <span class="dc-tag">Check performance</span>
                <h3 class="dc-h">
                    성과도 확실하게<br />쏙쏙 확인해보세요.
                </h3>
                <img src={IMG.perfCard} alt="성과 확인 기능" class="perf-img" />
            </div>
        </div>
    </section>

    <!-- ── AI Manager ── -->
    <section class="sec ai-sec">
        <div class="idx-wrap">
            <h2 class="sh">
                복잡한 설정없이<br />메모장 쓰듯 몇줄 적으면 끝나요.
            </h2>
            <p class="sp">
                평소 안내하던 내용만 툭 적어주세요. 대답부터 맞춤 링크 안내까지
                해주는 똑똑한 AI매니저가 만들어져요.
            </p>
            <div class="ai-cards">
                <div class="ai-card ai-text-card">
                    <span class="dc-tag">텍스트로 완성</span>
                    <h3 class="dc-h">
                        텍스트 몇 줄로 완성하는<br />똑똑한 AI 매니저
                    </h3>
                    <img
                        src={IMG.aiTextCard}
                        alt="AI 텍스트 입력"
                        class="ai-text-img"
                    />
                </div>
                <div class="ai-card ai-phone-card">
                    <span class="dc-tag">AI 매니저</span>
                    <h3 class="dc-h">
                        나만의 똑똑한<br />AI 매니저를 확인하세요.
                    </h3>
                    <img
                        src={IMG.aiPhoneCard}
                        alt="AI 매니저 화면"
                        class="ai-phone-img"
                    />
                </div>
            </div>
        </div>
    </section>

    <!-- ── Feature showcase ── -->
    <section class="sec feature-sec">
        <div class="idx-wrap">
            <div class="feat-grid">
                <!-- row1 col1: section heading -->
                <div class="feat-heading">
                    <h2 class="sh">
                        어떤 일을 하시든,<br />아바톡 하나면 충분해요.
                    </h2>
                    <p class="sp">
                        오프라인 매장부터 1인 기업, 크리에이터까지<br
                        />비즈니스를 알리고 싶은 누구나 쉬운 정답이 되어드려요.
                    </p>
                </div>
                <!-- row1 col2: 모바일 미니 페이지 card (시작점이 위) -->
                <div class="feat-card feat-mini-card">
                    <span class="dc-tag">프로모션 안내부터 상담 문의까지</span>
                    <h3 class="dc-h">모바일 미니 페이지</h3>
                    <img
                        src={IMG.featMiniP_l}
                        alt=""
                        class="feat-mini-phone feat-mini-pl"
                    />
                    <img
                        src={IMG.featMiniP_r}
                        alt=""
                        class="feat-mini-phone feat-mini-pr"
                    />
                    <img
                        src={IMG.featMiniP_c}
                        alt=""
                        class="feat-mini-phone feat-mini-pc"
                    />
                </div>
                <!-- row2 col1: 모바일 명함 card -->
                <div class="feat-card feat-mobile-card">
                    <span class="dc-tag">고객과의 소통을 연결하는</span>
                    <h3 class="dc-h">모바일 명함</h3>
                    <img
                        src={IMG.featMobileCards}
                        alt=""
                        class="feat-mobile-cards-img"
                    />
                    <img
                        src={IMG.featMobilePhone}
                        alt=""
                        class="feat-mobile-phone-img"
                    />
                </div>
                <!-- row2 col2: 캐릭터 랜딩페이지 & AI 채팅 card -->
                <div class="feat-card feat-char-card">
                    <span class="dc-tag">나만의 캐릭터 랜딩페이지 제작</span>
                    <h3 class="dc-h">캐릭터 랜딩페이지<br />&amp; AI 채팅</h3>
                    <img
                        src={IMG.featCharPhone}
                        alt=""
                        class="feat-char-phone-img"
                    />
                </div>
            </div>
            <div class="tmpl-gallery-card">
                <span class="dc-tag">전체 템플릿</span>
                <h3 class="dc-h">다양한 템플릿을<br />사용해보세요.</h3>
                <button
                    class="btn-text-arrow"
                    on:click={() => navigateTo("/usecase")}
                >
                    더 많은 템플릿 둘러보기
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                        aria-hidden="true"
                    >
                        <path
                            d="M3 8h10M9 4l4 4-4 4"
                            stroke="#6B7684"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
                <img
                    src={IMG.tmplGallP_l}
                    alt=""
                    class="tmpl-gall-phone tmpl-gall-pl"
                />
                <img
                    src={IMG.tmplGallP_c}
                    alt=""
                    class="tmpl-gall-phone tmpl-gall-pc"
                />
                <img
                    src={IMG.tmplGallP_r}
                    alt=""
                    class="tmpl-gall-phone tmpl-gall-pr"
                />
            </div>
        </div>
    </section>

    <!-- ── Dark CTA ── -->
    <section class="cta-sec">
        <div class="cta-inner">
            <div class="cta-brand">AVATALK</div>
            <div class="cta-h">
                비용 부담없이, 지금 바로 비즈니스를 알려 보세요.
            </div>
            <button class="btn-cta-dark" on:click={() => navigateTo("/join")}>
                무료로 제작하기
            </button>
        </div>
    </section>
</div>

<style>
    /* ── Reset ── */
    #idx {
        font-family:
            "Pretendard",
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            sans-serif;
        color: #3c3d46;
        background: #fff;
        overflow-x: hidden;
    }
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    button {
        font-family: inherit;
        cursor: pointer;
        border: none;
        background: none;
    }
    a {
        text-decoration: none;
    }

    /* ── Hero ── */
    .hero {
        position: relative;
        min-height: 880px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        padding-top: 84px;
    }

    .hero-blur {
        position: absolute;
        border-radius: 50%;
        filter: blur(120px);
        pointer-events: none;
    }
    .hero-blur.pink {
        width: 773px;
        height: 773px;
        background: rgba(229, 94, 137, 0.08);
        top: -154px;
        left: -100px;
    }
    .hero-blur.blue {
        width: 910px;
        height: 871px;
        background: rgba(194, 224, 255, 0.4);
        bottom: -200px;
        right: -120px;
    }

    .hero-content {
        position: relative;
        z-index: 1;
        width: 100%;
        max-width: 1080px;
        margin: 0 auto;
        padding: 0 48px;
        text-align: center;
        /* 슬라이드 높이 확보 - active 슬라이드만 문서 흐름에 포함 */
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    /* Slider: 고정 높이 컨테이너로 controls 위치 고정 */
    .slides-outer {
        position: relative;
        width: 100%;
        min-height: 320px;
        margin-bottom: 32px;
    }
    .slide {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.45s ease;
    }
    .slide.active {
        opacity: 1;
        pointer-events: auto;
    }

    /* 브랜드 로고 + AVATALK 인라인 */
    .brand-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 14px;
        margin-bottom: 16px;
    }
    .brand-icon {
        width: 71px;
        height: 68px;
        object-fit: contain;
    }
    .brand {
        font-size: 70px;
        font-weight: 700;
        color: #3c3d46;
        line-height: 1;
        letter-spacing: -2px;
    }

    /* 헤드라인 + 아이콘 행 */
    .hero-h-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin-bottom: 20px;
        min-height: 60px;
    }
    .hero-h {
        font-size: 40px;
        font-weight: 700;
        color: #3c3d46;
        line-height: 1.25;
        text-align: center;
    }
    .hero-icon {
        width: 60px;
        height: 60px;
        object-fit: contain;
        flex-shrink: 0;
    }

    .hero-sub {
        font-size: 22px;
        font-weight: 500;
        color: #6b7684;
        margin-bottom: 40px;
        line-height: 1.6;
    }

    .btn-cta {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 22px;
        font-weight: 600;
        color: #fff;
        background: #e55e89;
        border-radius: 30px;
        padding: 6px 28px;
        height: 48px;
        transition:
            opacity 0.15s,
            transform 0.15s;
    }
    .btn-cta:hover {
        opacity: 0.88;
        transform: translateY(-2px);
    }

    /* Controls */
    .hero-controls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 60px;
    }
    .ctrl-arrow {
        width: 52px;
        height: 52px;
        background: none;
        border: none;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
        transition: opacity 0.15s;
    }
    .ctrl-arrow:hover {
        opacity: 0.5;
    }
    .dots {
        display: flex;
        gap: 20px;
        align-items: center;
    }
    .dot {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #d8d8d8;
        border: none;
        padding: 0;
        cursor: pointer;
        transition:
            background 0.2s,
            transform 0.2s;
    }
    .dot.active {
        background: #717171;
        transform: scale(1.1);
    }

    /* ── Sections base ── */
    .sec {
        background: #fff;
    }
    .idx-wrap {
        max-width: 1280px;
        margin: 0 auto;
        padding: 100px 48px;
    }
    .tag {
        display: block;
        font-size: 18px;
        font-weight: 500;
        color: #6b7684;
        margin-bottom: 16px;
    }
    .sh {
        font-size: 34px;
        font-weight: 700;
        line-height: 1.25;
        margin-bottom: 20px;
        text-align: center;
    }
    .sp {
        font-size: 16px;
        font-weight: 500;
        color: #6b7684;
        line-height: 1.75;
        margin-bottom: 48px;
        text-align: center;
    }
    .grid-2 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
    }

    /* ── Problem section ── */
    .problem-sec {
        background: #fff;
    }
    .prob-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 80px;
        align-items: center;
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .prob-text .sh {
        margin-bottom: 20px;
        text-align: left;
    }
    .prob-text .sp {
        margin-bottom: 0;
        font-size: 16px;
        text-align: left;
    }
    .prob-img img {
        width: 100%;
        object-fit: contain;
        border-radius: 20px;
    }

    /* ── BA section ── */
    .ba-sec {
        background: #f7f8fa;
    }

    /* BA Cards */
    .ba-card {
        position: relative;
        overflow: hidden;
        border-radius: 44px;

        padding: 28px 28px 0;
        aspect-ratio: 465 / 379;
    }
    .before-card {
        border: 2.25px solid transparent;
        background:
            linear-gradient(
                    to bottom,
                    rgba(229, 94, 137, 0.3) 0%,
                    rgba(246, 188, 207, 0.4) 13%,
                    rgba(255, 242, 247, 0.8) 24%,
                    #fff 100%
                )
                padding-box,
            linear-gradient(
                    to bottom,
                    rgba(255, 241, 241, 0) 20%,
                    rgba(255, 241, 241, 1) 100%
                )
                border-box;
    }
    .after-card {
        border: 2.25px solid transparent;
        background:
            linear-gradient(
                    to bottom,
                    rgba(194, 225, 255, 1) 0%,
                    rgba(236, 244, 252, 0.2) 25%,
                    rgba(236, 244, 252, 0.4) 86%,
                    #fff 100%
                )
                padding-box,
            linear-gradient(
                    to bottom,
                    rgba(247, 246, 249, 0) 20%,
                    rgba(247, 246, 249, 1) 100%
                )
                border-box;
    }
    .ba-card-label {
        display: block;
        font-size: 16px;
        font-weight: 500;
        color: #232527;
        margin-bottom: 16px;
        position: relative;
        z-index: 1;
    }
    .ba-card-h {
        font-size: 24px;
        font-weight: 700;
        line-height: 1.3;
        color: #1e1f22;
        position: relative;
        z-index: 1;
    }
    /* Before – 폰 일러스트 */
    .ba-hero-img {
        position: absolute;
        right: -1%;
        bottom: 0;
        width: 64%;
        height: auto;
        pointer-events: none;
    }
    /* After – 아이콘 그리드 + 화살표 */
    .after-icons-area {
        position: absolute;
        left: 11.3%;
        top: 48.7%;
        display: flex;
        align-items: center;
        gap: 14px;
        z-index: 1;
    }
    .after-icons-grid {
        display: grid;
        grid-template-columns: repeat(2, 68px);
        gap: 6px;
    }
    .after-icon {
        width: 100%;
        display: block;
        border-radius: 12px;
    }
    .after-arrow {
        flex-shrink: 0;
        opacity: 0.65;
    }
    /* After – 폰 목업 */
    .after-phone-img {
        position: absolute;
        right: 7.1%;
        top: 21.7%;
        width: 31%;
        height: auto;
        pointer-events: none;
    }

    /* ── Drag & Drop ── */
    .dragdrop-sec {
        background: #fff;
    }
    .dragdrop-sec .idx-wrap {
        padding-bottom: 60px;
    }
    .dd-card {
        display: flex;
        align-items: stretch;
        border-radius: 44px;
        overflow: hidden;
        aspect-ratio: 960 / 485;
        margin-top: 48px;
        border: 2.25px solid transparent;
        background:
            #fff padding-box,
            linear-gradient(
                    to bottom,
                    rgba(247, 246, 249, 1) 0%,
                    rgba(255, 241, 241, 0) 45.2%,
                    rgba(255, 241, 241, 1) 100%
                )
                border-box;
    }
    .dd-text {
        flex: 0 0 35%;
        padding: 37px 0 37px 37px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .dd-tag {
        font-size: 16px;
        font-weight: 500;
        color: #6b7684;
        display: block;
        margin-bottom: 24px;
    }
    .dd-card-h {
        font-size: 28px;
        font-weight: 700;
        line-height: 1.3;
        color: #3c3d46;
    }
    .dd-img-wrap {
        flex: 1;
        padding: 30px 35px 30px 0;
        display: flex;
        align-items: stretch;
    }
    .dd-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: left top;
        display: block;
        border-radius: 16px;
    }

    /* ── Dual ── */
    .dual-sec {
        background: #f7f8fa;
    }
    .dual-cards {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 30px;
    }
    .dual-card {
        background: #fff;
        aspect-ratio: 465 / 624;
        position: relative;
        overflow: hidden;
        border-radius: 44px;

        padding: 37px 0 0 44px;
    }
    .dc-tag {
        font-size: 16px;
        font-weight: 500;
        color: #6b7684;
        display: block;
        margin-bottom: 24px;
    }
    .dc-h {
        font-size: 28px;
        font-weight: 700;
        line-height: 1.3;
        color: #3c3d46;
    }
    /* Perf card – chart image */
    .perf-img {
        position: absolute;
        left: 5.8%;
        top: 31.6%;
        width: 88.4%;
        height: auto;
        pointer-events: none;
    }
    /* Template card – two overlapping phones */
    .tmpl-phone {
        position: absolute;
        bottom: 0;
        height: auto;
        pointer-events: none;
    }
    .tmpl-phone-1 {
        left: 12.3%;
        width: 47.7%;
    }
    .tmpl-phone-2 {
        left: 40%;
        width: 47.7%;
        z-index: 1;
    }

    /* ── AI ── */
    .ai-sec {
        background: #fff;
    }
    .ai-cards {
        display: grid;
        grid-template-columns: 585fr 344fr;
        gap: 31px;
    }
    .ai-card {
        position: relative;
        overflow: hidden;
        border-radius: 44px;

        padding: 37px 0 0 44px;
    }
    .ai-text-card {
        aspect-ratio: 585 / 600;
        border: 2.25px solid transparent;
        background:
            linear-gradient(
                    to bottom,
                    rgba(229, 94, 137, 0.28) 0%,
                    rgba(246, 188, 206, 0.38) 13%,
                    rgba(255, 242, 246, 0.75) 25%,
                    #fff 100%
                )
                padding-box,
            linear-gradient(
                    to bottom,
                    rgba(255, 241, 241, 0) 20%,
                    rgba(255, 241, 241, 1) 100%
                )
                border-box;
    }
    .ai-phone-card {
        aspect-ratio: 344 / 600;
        border: 2.25px solid transparent;
        background:
            linear-gradient(
                    to bottom,
                    rgba(194, 225, 255, 1) 0%,
                    rgba(236, 244, 252, 0.2) 24%,
                    rgba(236, 244, 252, 0.4) 88%,
                    #fff 100%
                )
                padding-box,
            linear-gradient(
                    to bottom,
                    rgba(247, 246, 249, 0) 7.5%,
                    rgba(247, 246, 249, 1) 35.9%
                )
                border-box;
    }
    .ai-text-img {
        position: absolute;
        left: 4.6%;
        top: 30.2%;
        width: 90.8%;
        height: auto;
        pointer-events: none;
    }
    .ai-phone-img {
        position: absolute;
        left: 15.2%;
        top: 29.6%;
        width: 69.9%;
        height: auto;
        pointer-events: none;
    }
    .ai-sec .sp {
        margin-bottom: 40px;
    }

    /* ── Feature ── */
    .feature-sec {
        background: #f7f8fa;
    }
    .feat-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto;
        gap: 38px;
        align-items: start;
    }
    .feat-heading {
        grid-column: 1;
        grid-row: 1;
        /* Figma stagger: section text starts ~35% into right-card height */
        padding-top: 18%;
    }
    .feat-heading .sp {
        margin-bottom: 0;
    }
    .feat-mini-card {
        grid-column: 2;
        grid-row: 1;
        aspect-ratio: 464 / 481;
    }
    .feat-mobile-card {
        grid-column: 1;
        grid-row: 2;
        aspect-ratio: 464 / 482;
    }
    .feat-char-card {
        grid-column: 2;
        grid-row: 2;
        aspect-ratio: 464 / 481;
    }
    .feat-card {
        background: #fff;
        border: 2.25px solid rgba(145, 145, 145, 0.35);
        border-radius: 44px;
        overflow: hidden;
        position: relative;
        padding: 37px 0 0 40px;
    }
    /* feat-mini phones */
    .feat-mini-phone {
        position: absolute;
        height: auto;
        pointer-events: none;
    }
    .feat-mini-pl {
        left: 7.1%;
        top: 32.8%;
        width: 37.9%;
    }
    .feat-mini-pr {
        left: 58.8%;
        top: 32.8%;
        width: 36.4%;
    }
    .feat-mini-pc {
        left: 30.2%;
        top: 24.5%;
        width: 42.5%;
        z-index: 1;
    }
    /* feat-mobile phones */
    .feat-mobile-phone-img {
        position: absolute;
        left: 50.2%;
        top: 19.9%;
        width: 44%;
        height: auto;
        pointer-events: none;
    }
    .feat-mobile-cards-img {
        position: absolute;
        left: 6.5%;
        top: 29.5%;
        width: 40.3%;
        height: auto;
        pointer-events: none;
    }

    /* feat-char phones */
    .feat-char-phone-img {
        position: absolute;
        left: 9.3%;
        top: 32.2%;
        width: 79.6%;
        height: auto;
        pointer-events: none;
    }

    /* ── Template gallery ── */
    .tmpl-gallery-card {
        position: relative;
        overflow: hidden;
        border-radius: 44px;
        aspect-ratio: 960 / 485;
        padding: 50px 0 0 40px;
        margin-top: 38px;
        border: 2.25px solid transparent;
        background-image: radial-gradient(
                ellipse 150% 160% at 50% -5%,
                rgba(194, 224, 255, 0.65) 0%,
                transparent 65%
            ),
            radial-gradient(
                ellipse 130% 80% at 40% 115%,
                rgba(229, 94, 137, 0.3) 0%,
                transparent 60%
            ),
            linear-gradient(#fff, #fff),
            linear-gradient(
                243deg,
                rgba(247, 246, 249, 1) 0%,
                rgba(255, 241, 241, 0) 45.2%,
                rgba(255, 241, 241, 1) 100%
            );
        background-clip: padding-box, padding-box, padding-box, border-box;
        background-origin: padding-box, padding-box, padding-box, border-box;
    }
    /* template gallery phones */
    .tmpl-gall-phone {
        position: absolute;
        height: auto;
        pointer-events: none;
    }
    .tmpl-gall-pl {
        left: 39.7%;
        top: 16%;
        width: 25.6%;
    }
    .tmpl-gall-pc {
        left: 55.5%;
        top: 10.6%;
        width: 25.6%;
        z-index: 1;
    }
    .tmpl-gall-pr {
        left: 72.2%;
        top: 16%;
        width: 24.8%;
    }
    .btn-text-arrow {
        position: absolute;
        bottom: 8.7%;
        left: 3.1%;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 16px;
        font-weight: 500;
        color: #6b7684;
        cursor: pointer;
    }
    .btn-text-arrow:hover {
        color: #3c3d46;
    }

    /* ── Dark CTA ── */
    .cta-sec {
        background: #272f3a;
        overflow: hidden;
    }
    .cta-inner {
        max-width: 1280px;
        margin: 0 auto;
        padding: 100px 48px 80px;
        text-align: center;
    }
    .cta-brand {
        font-size: 70px;
        font-weight: 700;
        color: #fff;
        letter-spacing: -1px;
        margin-bottom: 40px;
    }
    .cta-h {
        font-size: 40px;
        font-weight: 600;
        color: #fff;
        line-height: 1.35;
        margin-bottom: 48px;
    }
    .btn-cta-dark {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 22px;
        font-weight: 700;
        color: #fff;
        background: rgba(0, 0, 0, 0);
        border: 2px solid rgba(255, 255, 255, 0.5);
        border-radius: 30px;
        padding: 10px 28px;
        height: 54px;
        backdrop-filter: blur(8px);
        transition: background 0.15s;
    }
    .btn-cta-dark:hover {
        background: rgba(255, 255, 255, 0.08);
    }
    .cta-shot {
        width: 100%;
        display: block;
        object-fit: cover;
        max-height: 340px;
    }

    /* ── Responsive ── */
    @media (max-width: 1024px) {
        .idx-wrap {
            padding: 80px 24px;
        }
        .sh {
            font-size: 38px;
        }
        .brand {
            font-size: 64px;
        }
        .brand-icon {
            width: 56px;
            height: 54px;
        }
        .hero-h {
            font-size: 44px;
        }
        .hero-icon {
            width: 50px;
            height: 50px;
        }
        .hero-h-row {
            min-height: 50px;
        }
        .slides-outer {
            min-height: 380px;
        }
        .prob-grid {
            grid-template-columns: 1fr;
            gap: 40px;
        }
        .prob-img {
            order: -1;
        }
    }

    @media (max-width: 768px) {
        .hero {
            min-height: 700px;
            padding-top: 72px;
        }
        .ba-card {
            aspect-ratio: unset;
            min-height: 280px;
            border-radius: 28px;
            padding: 22px 22px 0;
        }
        .ba-card-h {
            font-size: 22px;
        }
        .ba-hero-img {
            width: 58%;
        }
        .after-phone-img {
            right: 0;
            top: auto;
            bottom: 0;
            width: 30%;
        }
        .after-icons-area {
            position: relative;
            left: auto;
            top: auto;
            margin-top: 24px;
            gap: 10px;
        }
        .after-icons-grid {
            grid-template-columns: repeat(2, 46px);
            gap: 6px;
        }
        .dd-card {
            flex-direction: column;
            aspect-ratio: unset;
            border-radius: 28px;
        }
        .dd-text {
            flex: none;
            padding: 24px 24px 16px;
        }
        .dd-card-h {
            font-size: 22px;
        }
        .dd-img-wrap {
            padding: 0 16px 16px;
        }
        .dd-img {
            border-radius: 12px;
            height: auto;
        }
        .dual-cards {
            grid-template-columns: 1fr;
            gap: 16px;
        }
        .dual-card {
            aspect-ratio: 465 / 500;
            border-radius: 28px;
            padding: 28px 0 0 32px;
        }
        .dc-h {
            font-size: 22px;
        }
        .tmpl-phone-1 {
            width: 35%;
            left: 6%;
        }
        .tmpl-phone-2 {
            width: 35%;
            left: 36%;
        }
        .ai-cards {
            grid-template-columns: 1fr;
            gap: 16px;
        }
        .ai-card {
            border-radius: 28px;
            padding: 28px 0 0 32px;
        }
        .ai-text-card {
            aspect-ratio: 585 / 480;
        }
        .ai-phone-card {
            aspect-ratio: 408 / 480;
        }
        .brand {
            font-size: 48px;
        }
        .brand-icon {
            width: 44px;
            height: 42px;
        }
        .hero-h {
            font-size: 32px;
        }
        .hero-icon {
            width: 40px;
            height: 40px;
        }
        .hero-h-row {
            min-height: 40px;
        }
        .hero-sub {
            font-size: 16px;
        }
        .slides-outer {
            min-height: 320px;
        }
        .sh {
            font-size: 30px;
        }
        .sp {
            font-size: 17px;
        }
        .grid-2 {
            grid-template-columns: 1fr;
        }
        .cta-brand {
            font-size: 48px;
        }
        .cta-h {
            font-size: 28px;
        }
        /* Feature / Template */
        .feat-grid {
            grid-template-columns: 1fr;
            grid-template-rows: unset;
            gap: 20px;
        }
        .feat-heading {
            grid-column: 1;
            grid-row: unset;
            padding-top: 0;
        }
        .feat-mini-card,
        .feat-mobile-card,
        .feat-char-card {
            grid-column: 1;
            grid-row: unset;
        }
        .feat-heading .sh,
        .feat-heading .sp {
            text-align: center;
        }
        .feat-card {
            aspect-ratio: unset;
            min-height: 300px;
            border-radius: 28px;
            padding: 28px 0 0 28px;
        }
        .tmpl-gallery-card {
            aspect-ratio: unset;
            min-height: 260px;
            border-radius: 28px;
            padding: 32px 0 0 28px;
        }
        .tmpl-gall-phone {
            width: 22%;
        }
        .tmpl-gall-pl {
            left: 38%;
            top: 15%;
        }
        .tmpl-gall-pc {
            left: 55%;
            top: 9%;
        }
        .tmpl-gall-pr {
            left: 72%;
            top: 15%;
        }
        .btn-text-arrow {
            font-size: 14px;
            bottom: 10%;
        }
    }

    @media (max-width: 480px) {
        /* dual-cards */
        .dual-card {
            aspect-ratio: 465 / 500;
            border-radius: 22px;
            padding: 20px 0 0 22px;
        }
        .dc-h {
            font-size: 20px;
        }
        .tmpl-phone-1 {
            width: 28%;
            left: 4%;
        }
        .tmpl-phone-2 {
            width: 28%;
            left: 36%;
        }
        /* feat-cards: increase min-height + push images below text (~128px) */
        .feat-card {
            min-height: 380px;
        }
        .feat-mini-pl,
        .feat-mini-pr {
            top: 45%;
        }
        .feat-mini-pc {
            top: 40%;
        }
        .feat-mobile-phone-img {
            top: 45%;
        }
        .feat-mobile-cards-img {
            top: 43%;
        }
        .feat-char-phone-img {
            top: 45%;
        }
        /* tmpl-gallery phones: too small at 480px, hide cleanly */
        .tmpl-gall-phone {
            display: none;
        }
        /* ai-text-img / perf-img: buffer below text */
        .ai-text-img {
            top: 40%;
        }
        .perf-img {
            top: 38%;
        }
        .ba-card {
            min-height: 240px;
            padding: 18px 18px 0;
            border-radius: 22px;
        }
        .ba-card-h {
            font-size: 20px;
        }
        .ba-hero-img {
            width: 52%;
        }
        .after-phone-img {
            width: 26%;
        }
        .after-icons-grid {
            grid-template-columns: repeat(2, 40px);
            gap: 5px;
        }
        .after-icons-area {
            margin-top: 18px;
            gap: 8px;
        }
        .dd-card {
            border-radius: 22px;
        }
        .dd-text {
            padding: 20px 20px 12px;
        }
        .dd-card-h {
            font-size: 19px;
        }
        .hero-content {
            padding: 0 20px;
        }
        .idx-wrap {
            padding: 60px 20px;
        }
        .brand {
            font-size: 36px;
        }
        .brand-icon {
            width: 34px;
            height: 32px;
        }
        .hero-h {
            font-size: 24px;
        }
        .hero-h-row {
            gap: 8px;
            min-height: 32px;
        }
        .hero-icon {
            width: 32px;
            height: 32px;
        }
        .slides-outer {
            min-height: 280px;
        }
        .btn-cta {
            font-size: 16px;
        }
    }
</style>
